import { render, staticRenderFns } from "./ReviewListings.vue?vue&type=template&id=564893ce&"
import script from "./ReviewListings.vue?vue&type=script&lang=js&"
export * from "./ReviewListings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports